import { Route, Routes } from "react-router-dom";
import { NavItems } from "@helpers/navigation";
import { AdminShell } from "@fadmin/components/AdminShell";
import { SupportTraining } from "./supportTraining";

export const DocumentationLanding = (): JSX.Element => {
    const routes = (
        <Routes>
            <Route path="*" element={<SupportTraining />} />
            <Route path={NavItems.Documentation.SupportTraning.relativePath} element={<SupportTraining />} />
        </Routes>
    );

    return <AdminShell routes={routes} />;
};
